import React from 'react';
import { Table } from 'semantic-ui-react';
import Detalhes from './Detalhes';
import { dateIdToFormat, numFormat } from '@rededompedro/utils';

export default function Payment({ payment }) {
    return (
        <Table.Row>
            <Table.Cell>{payment.nome_empresa}</Table.Cell>
            <Table.Cell>R$ {numFormat(payment.valor_total)}</Table.Cell>
            <Table.Cell textAlign="center">{payment.type}</Table.Cell>
            <Table.Cell>{payment.cidade}</Table.Cell>
            <Table.Cell textAlign="center">
                {dateIdToFormat(payment.data_pgto, 'dd/MM/yyyy')}
            </Table.Cell>
            <Table.Cell textAlign="center">{payment.estado}</Table.Cell>
            <Table.Cell textAlign="center">{payment.status}</Table.Cell>
            {!payment.detalhes ? (
                <Table.Cell />
            ) : (
                <Table.Cell textAlign="center">
                    <Detalhes payment={payment} details={payment.detalhes} />
                </Table.Cell>
            )}
        </Table.Row>
    );
}
